import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { HijriMomentDateAdapter } from 'src/app/shared/helpers/hijri-moment-date-adapter';

export const HIJRI_DATE_FORMATS = {
  parse: {
    dateInput: ['iYYYY/iM/iD', 'iYYYY-iM-iD', 'iD/iM/iYYYY'],
  },
  display: {
    dateInput: 'iD/iM/iYYYY',
    monthYearLabel: 'iMMMM iYYYY',
    dateA11yLabel: 'iD/iM/iYYYY',
    monthYearA11yLabel: 'iMMMM iYYYY',
  },
};

@Component({
  selector: 'app-hijri-user-data-input',
  template: `
    <div [formGroup]="formGroupParent">
      <mat-form-field appearance="outline" color="accent" class="full-width">
        <input
          matInput
          [formControlName]="controlName"
          [matDatepicker]="datePicker"
          autocomplete="off"
          [readonly]="readonly"
        />
        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
      </mat-form-field>
    </div>
  `,
  providers: [
    {
      provide: DateAdapter,
      useClass: HijriMomentDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: HIJRI_DATE_FORMATS,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'ar-SA',
    },
  ]
})
export class HijriUserDataInputComponent implements OnInit {
  @Input() formGroupParent: FormGroup;
  @Input() mode: any;
  @Input() userData: any;
  @Input() inputType: any;
  @Input() controlName: string;
  @Input() maxValue: string;
  @Input() readonly = false;
  @Input() listData: string[];

  ngOnInit() {}
}
